module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "showClose": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true,
      "autoFocusField": false,
      "isPrintable": true,
      "ariaLabel": "Kvoter"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v("Kvoter")]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__subtitle"
  }, [_vm._v("\n          Restkvote i KMD pr. " + _vm._s(_vm.quotaDateLabel) + ". Vælg en dato frem i tiden — f.eks. efter efterårsferien eller før påske — for at se, hvad der stadig skal afholdes inden udløb eller udbetaling.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__date"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Restkvote pr.")]), _vm._v(" "), _c('DateSelector', {
    attrs: {
      "date": _vm.selectedDate
    },
    on: {
      "changed": _vm.onDateChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-modal__select"
  }, [(_vm.selectAll) ? _c('div', {
    staticClass: "d-modal__all-selected"
  }, [_c('span', [_vm._v("Alle medarbejdere"), (_vm.selectedUserCount > 0) ? _c('span', [_vm._v(" (" + _vm._s(_vm.selectedUserCount) + ")")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "d-modal__all-selected__clear",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearSelectAll
    }
  }, [_vm._v("\n          Fravælg\n        ")])]) : [_c('DSelectUsers', {
    attrs: {
      "showTags": true,
      "showCreateButton": false
    },
    on: {
      "usersUpdated": _vm.onUsersUpdated
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn d-modal__select-all",
    attrs: {
      "type": "button",
      "disabled": _vm.opusEmployments.length === 0
    },
    on: {
      "click": _vm.selectAllUsers
    }
  }, [_vm._v("\n          Vælg alle\n        ")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__toolbar"
  }, [_c('div', {
    staticClass: "d-modal__toolbar__filters"
  }, [(_vm.quotaTypes.length > 0) ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Kvotetype',
      "tags": _vm.quotaTypes,
      "selectedTags": _vm.selectedQuotaTypes,
      "numberOfSelectedTagsToShow": 1,
      "placeholder": 'Vælg kvotetype'
    },
    on: {
      "select": _vm.toggleQuotaType,
      "clear": function($event) {
        _vm.selectedQuotaTypes = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasLoaded) ? _c('span', {
    staticClass: "d-modal__count"
  }, [_vm._v("\n          Viser " + _vm._s(_vm.filteredRows.length) + " af " + _vm._s(_vm.allRows.length) + " kvoter\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isDownloadingExcel
    },
    attrs: {
      "disabled": _vm.isLoading || _vm.isDownloadingExcel || _vm.filteredRows.length === 0
    },
    on: {
      "click": _vm.downloadExcel
    }
  }, [_vm._v("\n        Download til excel\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(!_vm.hasSelection) ? _c('p', {
    staticClass: "d-modal__empty"
  }, [_vm._v("\n        Vælg medarbejdere, en gruppe eller alle for at hente kvoter.\n      ")]) : (_vm.isLoading) ? _c('div', {
    staticClass: "d-modal__status"
  }, [_c('Loader', {
    attrs: {
      "isSmall": true
    }
  }), _vm._v(" "), (_vm.totalCount > 0) ? _c('p', {
    staticClass: "d-modal__progress"
  }, [_vm._v("\n          Henter kvoter… " + _vm._s(_vm.loadedCount) + " / " + _vm._s(_vm.totalCount) + " ansættelser\n        ")]) : _vm._e()], 1) : (_vm.errorMessage) ? _c('div', {
    staticClass: "d-modal__error"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : (_vm.hasLoaded && _vm.allRows.length === 0) ? _c('p', {
    staticClass: "d-modal__empty"
  }, [_vm._v("\n        Der blev ikke fundet nogen kvoter.\n      ")]) : (_vm.hasLoaded && _vm.filteredRows.length === 0) ? _c('p', {
    staticClass: "d-modal__empty"
  }, [_vm._v("\n        Ingen kvoter matcher de valgte filtre.\n      ")]) : _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'userName'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('userName')
      }
    }
  }, [_vm._v("\n            Navn "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), (_vm.hasGroupLabels) ? _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'userTagsLabel'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('userTagsLabel')
      }
    }
  }, [_vm._v("\n            Grupper "), _c('span', {
    staticClass: "icon-menu-open"
  })]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'employmentLabel'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('employmentLabel')
      }
    }
  }, [_vm._v("\n            Ansættelse "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'quotaType'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('quotaType')
      }
    }
  }, [_vm._v("\n            Kontotype "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter is-number",
    class: {
      'th-sorter--active': _vm.sortBy === 'balance'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('balance')
      }
    }
  }, [_vm._v("\n            Saldo "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter is-number",
    class: {
      'th-sorter--active': _vm.sortBy === 'used'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('used')
      }
    }
  }, [_vm._v("\n            Brugt "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter is-number",
    class: {
      'th-sorter--active': _vm.sortBy === 'difference'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('difference')
      }
    }
  }, [_vm._v("\n            Forskel "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'periodLabel'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('periodLabel')
      }
    }
  }, [_vm._v("\n            Afholdelsesperiode "), _c('span', {
    staticClass: "icon-menu-open"
  })])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', {
      key: row.id
    }, [_c('td', [_vm._v(_vm._s(row.userName))]), _vm._v(" "), (_vm.hasGroupLabels) ? _c('td', [_vm._v(_vm._s(row.userTagsLabel))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employmentLabel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.quotaType))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.balance)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.used)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.difference)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.periodLabel))])])
  }), 0)]), _vm._v(" "), (_vm.warningMessage) ? _c('p', {
    staticClass: "d-modal__warning"
  }, [_vm._v(_vm._s(_vm.warningMessage))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bcb177ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/KmdQuotasModal.vue
// module id = 2110
// module chunks = 1